import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

// material-ui
import { Box, Typography, useMediaQuery, useTheme, IconButton } from '@mui/material';
import logo from '../../../assets/images/sentinel_logo.jpg';

// third party
import { CSVLink } from 'react-csv';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';

// project import
import ProfileSection from './ProfileSection';
import DatePickerStore from 'views/Stores/Insight/Calendar';
import { Download } from '@mui/icons-material';
// import CircleNotificationsOutlinedIcon from '@mui/icons-material/CircleNotificationsOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import * as actionTypes from 'store/actions';

const Header = ({ drawerToggle }) => {
  const pad = (num) => String(num).padStart(2, '0');

  const currentDate = useSelector((state) => state.customization.currentDate);
  const [selectedDate, setSelectedDate] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const location = window.location.pathname;

  console.log('current date is ', currentDate);

  useEffect(() => {
    const formattedDate = dayjs(currentDate).format('DD/MM/YYYY');
    setSelectedDate(formattedDate);
  }, [currentDate]);

  const prepareExportData = () => {
    const dataForExport = [];
    return dataForExport;
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // useEffect(() => {
  //   const id = setInterval(() => {
  //     window.location.reload();
  //   }, 60000);

  //   return () => clearInterval(id);
  // }, []);

  const menu = (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      PaperProps={{
        style: {
          marginTop: '4px'
        }
      }}
    >
      <MenuItem onClick={handleMenuClose}>
        <a
          href={`http://127.0.0.1:8000/download/evidence?date=${selectedDate}`}
          target="_blank"
          rel="noreferrer"
          className="w-28 flex items-center"
        >
          <Download className="mr-2" /> ZIP
        </a>
      </MenuItem>
      <MenuItem onClick={handleMenuClose}>
        <CSVLink
          data={prepareExportData()}
          filename={`analysis_data_${new Date().getFullYear()}${pad(new Date().getMonth() + 1)}${pad(new Date().getDate())}${pad(
            new Date().getHours()
          )}${pad(new Date().getMinutes())}${pad(new Date().getSeconds())}.csv`}
          target="_blank"
          className="w-full flex items-center"
        >
          <Download className="mr-2" /> .xls
        </CSVLink>
      </MenuItem>
    </Menu>
  );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: { xs: 1, sm: 1.5, md: 2 },
          px: { xs: 1, sm: 2, md: 3 },
          maxWidth: '100%',
          margin: '0 auto',
          height: { xs: '56px', sm: '64px' }
        }}
      >
        {/* Mobile menu toggle button - only visible on small screens */}
        {isMobile && (
          <IconButton color="inherit" aria-label="open drawer" onClick={drawerToggle} edge="start" sx={{ mr: 1, display: { sm: 'none' } }}>
            <MenuIcon />
          </IconButton>
        )}

        {/* Left section - Logo */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 0.5, sm: 1, md: 2 },
            height: '100%',
            flexShrink: 0,
            width: { xs: '20%', sm: '15%', md: '15%' },
            justifyContent: 'flex-start'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <img
              className="black cursor-pointer"
              src={logo}
              alt="logo"
              style={{
                width: 'clamp(25px, 4vw, 35px)',
                height: 'clamp(22px, 3.5vw, 30px)',
                objectFit: 'contain'
              }}
              onClick={() => window.open('/main/stores', '_self')}
            />

            <Typography
              onClick={() => window.open('/main/stores', '_self')}
              variant="h2"
              component="span"
              className="black cursor-pointer"
              sx={{
                fontSize: 'clamp(0.9rem, 1.5vw, 1.5rem)',
                paddingLeft: { xs: 0.5, sm: 1 },
                whiteSpace: 'nowrap',
                display: { xs: isMobile ? 'none' : 'block', sm: 'block' }
              }}
            >
              Sentinel
            </Typography>
          </Box>
        </Box>

        {/* Navigation Links - Left aligned with space from logo */}
        <Box
          sx={{
            display: { xs: 'none', sm: 'flex' },
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: { xs: '50%', sm: '60%', md: '60%' },
            px: { xs: 1, sm: 2 },
            ml: { xs: 2, sm: 3, md: 4 },
            gap: { xs: 2, sm: 3, md: 4 } // Adding horizontal spacing between child components
          }}
        >
          {false && (
            <Link
              to="/main/stores"
              onClick={() => dispatch({ type: actionTypes.MENU_OPEN, isOpen: 'stores' })}
              className={`text-lg hover:border-b-2 hover:text-[#44BE54] ${
                location === '/main/stores' ? 'border-b-2 border-[#44BE54] text-[#44BE54]' : ''
              }`}
              style={{
                textDecoration: 'none',
                padding: '0.5rem 1rem',
                fontSize: '1rem',
                color: location === '/main/stores' ? '#44BE54' : '#333',
                fontWeight: location === '/main/stores' ? '600' : '400',
                transition: 'all 0.3s ease',
                borderBottomColor: '#44BE54'
              }}
            >
              Stores
            </Link>
          )}

          {true && (
            <Link
              to="/main/stores/cameras"
              onClick={() => dispatch({ type: actionTypes.MENU_OPEN, isOpen: 'stores' })}
              className={`text-lg hover:border-b-2 hover:text-[#44BE54] ${
                location === '/main/stores/cameras' || location === '/main/stores' ? 'border-b-2 border-[#44BE54] text-[#44BE54]' : ''
              }`}
              style={{
                textDecoration: 'none',
                padding: '0.5rem 1rem',
                fontSize: '1rem',
                color: location === '/main/stores/cameras' || location === '/main/stores' ? '#44BE54' : '#333',
                fontWeight: location === '/main/stores/cameras' || location === '/main/stores' ? '600' : '400',
                transition: 'all 0.3s ease',
                borderBottomColor: '#44BE54'
              }}
            >
              Cameras
            </Link>
          )}

          {false && (
            <Link
              to="/main/stores/team"
              onClick={() => dispatch({ type: actionTypes.MENU_OPEN, isOpen: 'stores' })}
              className={`text-lg hover:border-b-2 hover:text-[#44BE54] ${
                location === '/main/stores/team' ? 'border-b-2 border-[#44BE54] text-[#44BE54]' : ''
              }`}
              style={{
                textDecoration: 'none',
                padding: '0.5rem 1rem',
                fontSize: '1rem',
                color: location === '/main/stores/team' ? '#44BE54' : '#333',
                fontWeight: location === '/main/stores/team' ? '600' : '400',
                transition: 'all 0.3s ease',
                borderBottomColor: '#44BE54'
              }}
            >
              Team
            </Link>
          )}
          {/* <Link
            to="/temple"
            onClick={() => dispatch({ type: actionTypes.MENU_OPEN, isOpen: 'temple' })}
            className={`text-lg hover:border-b-2 hover:text-[#44BE54] ${
              location === '/temple' ? 'border-b-2 border-[#44BE54] text-[#44BE54]' : ''
            }`}
            style={{
              textDecoration: 'none',
              padding: '0.5rem 1rem',
              fontSize: '1rem',
              color: location === '/temple' ? '#44BE54' : '#333',
              fontWeight: location === '/temple' ? '600' : '400',
              transition: 'all 0.3s ease',
              borderBottomColor: '#44BE54'
            }}
          >
            Temple
          </Link> */}
        </Box>

        {/* Right section - Date picker, notifications, profile */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: { xs: 1.5, sm: 2, md: 2.5, xl: 3 },
            width: { xs: '100%', sm: 'auto' },
            flexShrink: 0,
            pr: { xs: 1, sm: 2 }
          }}
        >
          <DatePickerStore
            maxDate={new Date()}
            sx={{
              display: { xs: isMobile ? 'none' : 'block', sm: 'block' },
              '& .MuiInputBase-root': {
                height: { xs: '36px', sm: '40px' },
                fontSize: { xs: '0.7rem', sm: '0.75rem', xl: '0.875rem' },
                width: { xs: '110px', sm: '120px', md: '140px', xl: '160px' }
              }
            }}
          />

          {/* <IconButton
            aria-label="notifications"
            sx={{
              padding: { xs: 0.5, sm: 1 },
              '&:hover': { color: 'green' }
            }}
          >
            <CircleNotificationsOutlinedIcon
              sx={{
                fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                transition: 'transform 0.2s, color 0.2s',
                '&:hover': { transform: 'scale(1.1)', color: 'green' }
              }}
            />
          </IconButton> */}

          <ProfileSection />

          {/* <IconButton
            aria-label="chat"
            onClick={() => setChatOpen(true)}
            sx={{
              padding: 0.5,
              bgcolor: 'white',
              borderRadius: '50%',
              boxShadow: 1,
              transition: 'all 0.3s ease-in-out',
              '&:hover': {
                color: 'blue',
                bgcolor: '#e3f2fd',
                transform: 'scale(1.1)',
                boxShadow: 3
              },
              '&:active': {
                transform: 'scale(0.95)'
              }
            }}
          >
            <ChatBubbleOutlineIcon
              sx={{
                fontSize: '1.25rem',
                transition: 'transform 0.2s, color 0.2s'
              }}
            />
          </IconButton> */}

          {menu}
        </Box>
      </Box>
      {/* {chatOpen && <ChatWindow onClose={() => setChatOpen(false)} />} */}
    </>
  );
};

Header.propTypes = {
  drawerToggle: PropTypes.func
};

export default Header;
